import { useContext } from "react";
import { PirschClientContext } from "./PirschClientContext";

export const usePirschClient = () => {
  return useContext(PirschClientContext);
};
